import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate, useParams } from 'react-router'
import { PageSeo } from '@/components/layout/PageSeo'
import { legacyArticleSlugs } from '@/content/sitePaths'
import App from '@/App'
import WritingArticle from '@/pages/WritingArticle'

const SecretsMaconaria = lazy(() => import('@/pages/SecretsMaconaria'))
const DextroIotCore = lazy(() => import('@/pages/DextroIotCore'))
const NewHorizonChurch = lazy(() => import('@/pages/NewHorizonChurch'))

function PreviousEnglishArticle() {
  const { slug = '' } = useParams()
  return <Navigate replace to={`/writing/${legacyArticleSlugs[slug] ?? slug}`} />
}

export function SiteRoutes() {
  return (
    <>
      <PageSeo />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/writing/:slug" element={<WritingArticle />} />
        <Route path="/en-us" element={<Navigate replace to="/" />} />
        <Route path="/en-us/writing/:slug" element={<PreviousEnglishArticle />} />
        <Route path="/products/dextro-iot-core" element={<Suspense><DextroIotCore /></Suspense>} />
        <Route path="/mission/new-era/church" element={<Suspense><NewHorizonChurch /></Suspense>} />
        <Route path="/secrets/maconaria" element={<Suspense><SecretsMaconaria /></Suspense>} />
        <Route path="*" element={<WritingArticle />} />
      </Routes>
    </>
  )
}
